<template>
  <div
    class="text-[var(--foreground)] dark:bg-[var(--color-1)] dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] bg-[#eaeaea] overflow-hidden relative"
  >
    <WrOfficialPartnerHeader />
    <WrHeader />
    <WrBreadCrumb class="mt-32 z-30 relative" />

    <div class="pt-10">
      <main id="main-content">
        <slot />
      </main>
    </div>

    <section
      class="grid place-items-center z-10 relative max-md:pt-6 max-lg:mt-16 lg:mt-20 max-md:px-4 overflow-hidden"
      id="mask-section"
    >
      <LazyHydrationWrAnimatedImg
        :hydrate-on-visible="{ rootMargin: '100px' }"
      />
    </section>
    <LazyHydrationWrFooter :hydrate-on-visible="{ rootMargin: '100px' }" />
  </div>
</template>

<script setup lang="ts">
const WrHeader = defineAsyncComponent(
  () => import("~/components/molecules/WrHeader.vue")
);
const WrBreadCrumb = defineAsyncComponent(
  () => import("~/components/molecules/WrBreadCrumb.vue")
);
const LazyHydrationWrAnimatedImg = defineLazyHydrationComponent(
  "visible",
  () => import("~/components/molecules/WrAnimatedImg.vue")
);
const LazyHydrationWrFooter = defineLazyHydrationComponent(
  "visible",
  () => import("~/components/molecules/WrFooter.vue")
);
const WrOfficialPartnerHeader = defineAsyncComponent(
  () => import("~/components/molecules/WrOfficialPartnerHeader.vue")
);
</script>
